module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "positive-indicator"
  }, [_c('div', [(_vm.isPositive) ? _c('icon', {
    staticClass: "positive-indicator__plus",
    attrs: {
      "name": "plus",
      "scale": "1"
    }
  }) : (_vm.isNegative) ? _c('icon', {
    staticClass: "positive-indicator__minus",
    attrs: {
      "name": "minus",
      "scale": "1"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      'positive-indicator__number': true,
      'positive-indicator__number__positive': _vm.isPositive,
      'positive-indicator__number__negative': _vm.isNegative,
    }
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ad1e93e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/positiveityIndicator/PositiveityIndicator.vue
// module id = 1925
// module chunks = 0